import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Select } from '@ngxs/store';
import { InventoryState } from '../../states/inventory/inventory.state';
import { Observable } from 'rxjs';
import { IInventoryLocation } from '../../interfaces/inventory-location.interface';

@Component({
  selector: 'app-inventory-locations-filter',
  templateUrl: './inventory-locations-filter.component.html',
  styleUrls: ['./inventory-locations-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InventoryLocationsFilterComponent {
  @Input() control: UntypedFormControl;
  @Input() label: string = "";
  @Input() selectedItemsBadgeLimitCount = 3;

  @Select(InventoryState.locations) inventoryLocations$: Observable<IInventoryLocation[]>;

  config = {
    selectAllText: 'All Locations',
    allowSearchFilter: true,
    noDataAvailablePlaceholderText: 'No locations available',
    enableCheckAll: false
  };

  /**
   *
   */
  constructor(private cdr: ChangeDetectorRef) {
    
  }

  markForCheck(): void {
    this.cdr.markForCheck();
  }

}
